/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

export {
  propertyFormSchema,
  createPropertyFormSchema,
  DEFAULT_VALUES,
  getCategoryConfig,
  getCategoryLabel,
  getTransactionLabel,
  PROPERTY_CATEGORIES,
  RESIDENTIAL_CATEGORIES,
  APARTMENT_CATEGORIES,
  RURAL_CATEGORIES,
  LAND_CATEGORIES,
  NO_CONSTRUCTED_AREA_CATEGORIES,
  TRANSACTION_TYPES,
  SHORT_TERM_TRANSACTION,
  AUCTION_TRANSACTION,
  PROPERTY_CONDITIONS,
  OCCUPANCIES,
  FINISH_STANDARDS,
  LOCATION_QUALITIES,
  YES_NO_OPTIONS,
  LEISURE_AREAS,
  FACILITIES,
  SECURITY_ITEMS,
  INFRASTRUCTURE_ITEMS,
  CONDO_AMENITIES,
  CONDO_SECURITY,
  CATEGORY_LABELS,
  MANDATE_TYPES,
  FURNISHED_OPTIONS,
  FACING_OPTIONS,
  PARKING_TYPE_OPTIONS,
  RENTAL_PAYMENT_FREQUENCY_OPTIONS,
  RENTAL_INCLUDED_EXPENSES_OPTIONS,
  ADMINISTRATION_TYPE_OPTIONS,
  CONDO_INCLUDED_EXPENSES_OPTIONS,
  CONDO_PAID_BY_OPTIONS,
  PROPERTY_FIELD_LIMITS,
  maxYearBuilt,
} from '../PropertyFormDualPane/schema';

export type { PropertyFormValues } from '../PropertyFormDualPane/schema';

import {
  RENTAL_GUARANTEE_TYPES,
} from '@features/property-management/constants/rental-options';

export const RENTAL_GUARANTEE_OPTIONS = [...RENTAL_GUARANTEE_TYPES] as const;

export const BRAZILIAN_STATES = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA',
  'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN',
  'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
] as const;
